import { createReducer, on, Action } from '@ngrx/store';
import * as LoadingActions from './loading.actions';

export interface LoadingState {
  global: boolean;
  features: { [feature: string]: boolean };
}

export const initialState: LoadingState = {
  global: false,
  features: {},
};

const _loadingReducer = createReducer(
  initialState,
  on(LoadingActions.setLoading, (state, { loading, feature }) => {
    if (feature) {
      return {
        ...state,
        features: { ...state.features, [feature]: loading },
      };
    } else {
      return { ...state, global: loading };
    }
  }),
  on(LoadingActions.startLoading, (state, { feature }) => {
    if (feature) {
      return {
        ...state,
        features: { ...state.features, [feature]: true },
      };
    } else {
      return { ...state, global: true };
    }
  }),
  on(LoadingActions.stopLoading, (state, { feature }) => {
    if (feature) {
      return {
        ...state,
        features: { ...state.features, [feature]: false },
      };
    } else {
      return { ...state, global: false };
    }
  })
);

export function loadingReducer(
  state: LoadingState | undefined,
  action: Action
) {
  return _loadingReducer(state, action);
}
